<template>
  <div class="exchanges-grid">
    <div class="exchanges-grid__header">
      <h3> {{ label }} </h3>
      <BaseSwitch :disabled="disableSwitch" label="Activate Strategy" @change="updateBinanceTradingStatus" v-model="tradingStatus" />
    </div>
    <table class="exchanges-grid__table">

      <thead class="exchanges-grid__table__head">
        <tr>
          <th v-for="header in headers"
              :key="header.key"
              class="exchanges-grid__table__head__item"
              @click="sortItemsWith(header)"
          >
            <div class="exchanges-grid__table__head__item__label">
              {{ header.label }}
            </div>
            <div class="exchanges-grid__table__head__item__icon">
              <img src="@/assets/images/svg/arrows.svg" alt="arrows" />
            </div>
          </th>
        </tr>
      </thead>

      <tbody class="exchanges-grid__table__body">
        <tr v-for="(ticker, index) of tickers" :key="index" class="exchanges-grid__table__body__line">
          <td class="exchanges-grid__table__body__line__item">
            <img src="@/assets/images/svg/default-asset.svg" />

            <div class="exchanges-grid__table__body__line__item__label">
              {{ ticker.asset }}
            </div>
          </td>

          <td class="exchanges-grid__table__body__line__item--coin">
            <div class="exchanges-grid__table__body__line__item__label__up">
              {{ Math.floor(ticker.amount_value.value) }}$
            </div>
            <div class="exchanges-grid__table__body__line__item__label__down">
              ({{ ticker.amount_value.amount }})
            </div>
          </td>

          <td class="exchanges-grid__table__body__line__item exchanges-grid__table__body__line__item--coin">
            <div class="exchanges-grid__table__body__line__item__label__up">
              {{ ticker.price_changes.current_price }}$
            </div>
          </td>
        </tr>
      </tbody>

    </table>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { updateBinanceTradingStatus } from "@/services/account";
import BaseSwitch from "../ui/atoms/BaseSwitch.vue";
export default {
  name: "ExchangesGrid",
  props: {
    assets: {
      type: Array,
      default() {
        return [];
      },
    },
    label: {
      type: String,
      default: "",
    },
    disableSwitch: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      headers: [
        { label: "All Wallets", key: "asset", sorting: null },
        {
          label: "Value & Amount",
          key: "amount_value",
          subKey: "value",
          sorting: null,
        },
        {
          label: "Price",
          key: "price_changes",
          subKey: "current_price",
          sorting: null,
        },
      ],
      tickers: [],
      tradingStatus: false,
    };
  },
  computed: {
    ...mapGetters({
      getTradingBinanceStatus: "getTradingBinanceStatus",
    }),
  },
  watch: {
    getTradingBinanceStatus: {
      immediate: true,
      handler(changedValue) {
        if (changedValue !== undefined && !this.disableSwitch) {
          this.tradingStatus = changedValue;
        }
      },
    },
  },
  created() {
    this.tickers = [...this.assets];
    this.sortItemsWith({
      ...this.headers[1],
      sorting: "UP"
    })
  },
  methods: {
    ...mapActions({
      setBinanceKeys: "setBinanceKeys",
      setSnackbarError: "setSnackbarError",
    }),
    updateBinanceTradingStatus({ target: { checked } }) {
      updateBinanceTradingStatus({ status: checked })
        .then(() => this.setBinanceKeys({ trading_status: checked }))
        .catch(({ message }) => this.setSnackbarError(message));
    },
    sortItemsWith(header) {
      header.sorting = header.sorting === "UP" ? "DOWN" : "UP";
      if (header.sorting === "UP") {
        this.tickers.sort((a, b) => this.sortFunctionWith(a, b, header));
      } else {
        this.tickers.sort((a, b) => this.sortFunctionWith(b, a, header));
      }
    },
    sortFunctionWith(a, b, header) {
      const hasSubKey = header.subKey;
      if (hasSubKey) {
        return a[header.key][header.subKey] - b[header.key][header.subKey];
      } else {
        return a[header.key] - b[header.key];
      }
    },
  },
  components: { BaseSwitch },
};
</script>

<style lang="scss" scoped>
.exchanges-grid {
  width: 100%;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h3 {
      color: #868e96;
      font-size: 1.125rem;
    }
  }

  &__table {
    width: 100%;
    background: white;
    padding: 1rem;

    &__head {
      &__item {
        display: flex;
        align-items: center;
        gap: 0.625rem;
        cursor: pointer;

        &__icon {
          height: 1.125rem;
          width: 1.125rem;
          stroke: #adb5bd;
          color: #adb5bd;
          cursor: pointer;
        }

        &__label {
          color: #868e96;
          font-size: 1rem;
          font-weight: 500;
        }
      }

      tr {
        display: flex;
        justify-content: space-between;
        border-bottom: 2px solid #dee2e6;
        padding: 1.56rem 0;
      }

      th {
        width: 21%;
      }
    }

    &__body {
      &__line {
        display: flex;
        justify-content: space-between;
        padding-top: 1.56rem;

        &__item {
          &__label {
            &__down {
              font-size: 0.812rem;
              font-weight: 600;
              text-align: left;
            }

            &__up {
              text-transform: uppercase;
              font-size: 1rem;
              color: #212529;
              font-weight: 600;
              text-align: start;
            }
          }

          &__label,
          &--value {
            display: flex;
            flex-direction: column;
            gap: 0.375rem;
          }
        }

        td {
          width: 20%;
          padding: 0 0.625rem;
        }

        &__item {
          display: flex;
          align-items: center;
          gap: 0.125rem;

          img {
            height: 1.5rem;
            width: 1.5rem;
          }
        }
      }
    }
  }
}
</style>
